import { WS_LINKS } from "../../types/wsLinks";
import { getSupportRequestHandler } from "./supportRequestHandler";

const withMessageParam = (url: string, message?: string): string =>
  message ? `${url}?message=${encodeURIComponent(message)}` : url;

const openSupportPortalPopup = (url: string, message?: string) => {
  const width = 400;
  const height = 600;

  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    "resizable=yes",
    "scrollbars=yes",
    "status=no",
    "location=no",
    "toolbar=no",
    "menubar=no"
  ].join(",");

  window.open(withMessageParam(url, message), "targetWindow", features);

  console.info("Custom support portal is opened!");
};

const openSupportPageInNewTab = (url: string, message?: string) => {
  window.open(withMessageParam(url, message), "_blank", "noopener,noreferrer");
};

const getOrganizationSupportUrl = (): string | undefined =>
  window.organizationAccountConfig?.support?.portal?.generalUrl;

const openIntercomPanel = (): boolean => {
  if (!window.Intercom) return false;

  window.document.documentElement.setAttribute("data-show-intercom", "true");
  window.Intercom("show");
  window.Intercom("onHide", () => {
    window.document.documentElement.removeAttribute("data-show-intercom");
  });

  return true;
};

const openCustomSupportPortal = ({
  message,
  customURL
}: {
  message?: string;
  customURL?: any;
}): boolean => {
  const customSupportURL =
    typeof customURL === "string" ? customURL : getOrganizationSupportUrl();

  if (!customSupportURL) return false;

  openSupportPortalPopup(customSupportURL, message);

  return true;
};

const openSupport = (message?: string, customURL?: any) => {
  const handler = getSupportRequestHandler();

  if (handler) {
    handler();
    return;
  }

  if (openCustomSupportPortal({ customURL, message })) return;

  if (openIntercomPanel()) {
    if (message) {
      window.Intercom?.("showNewMessage", message);
    }
    return;
  }

  openSupportPageInNewTab(WS_LINKS.contractorSupportCenter, message);
};

export const openIntercom = (customURL?: any) => {
  openSupport(undefined, customURL);
};

export const openIntercomWithMessage = (
  message: string,
  customURL?: string
) => {
  openSupport(message, customURL);
};

export const openIntercomMessage = openIntercomWithMessage;
